import { createContext, FunctionComponent, useCallback, useContext, useEffect, useState } from "react";
import { discardEvent } from "../../utils/Utils";
import { useAuth } from "../Auth";

export type CommissionVisibility = {
  showCommissions: boolean;
  toggle: () => void;
};

const comVisibilityContext = createContext<CommissionVisibility>({
  showCommissions: false,
  toggle: discardEvent,
});

export const CommissionVisibilityProvider: FunctionComponent = ({ children }) => {
  const comVisibility = useComVisibilityProvider();
  return <comVisibilityContext.Provider value={comVisibility}>{children}</comVisibilityContext.Provider>;
};

export function useCommissionsVisibility() {
  return useContext(comVisibilityContext);
}

function useComVisibilityProvider(): CommissionVisibility {
  const auth = useAuth();
  const [mustShowCommissions, setMustShowCommissions] = useState(false);
  const itemKey = "seller.comVisibility";

  const toggle = useCallback(() => {
    if (!auth.loaded || !auth.user || !auth.isSeller) return;
    const newVal = !mustShowCommissions;
    localStorage.setItem(itemKey, String(newVal));
    setMustShowCommissions(newVal);
  }, [auth, mustShowCommissions, setMustShowCommissions]);

  useEffect(() => {
    if (auth.loaded && (!auth.user || !auth.isSeller)) localStorage.removeItem(itemKey);
    if (!auth.loaded || !auth.user || !auth.isSeller) return;
    setMustShowCommissions(Boolean(localStorage.getItem(itemKey) ?? false));
  }, [auth, setMustShowCommissions]);

  return { showCommissions: mustShowCommissions, toggle: toggle };
}
